import { render, staticRenderFns } from "./ArtworkIntakeList.vue?vue&type=template&id=13537c49&scoped=true&"
import script from "./ArtworkIntakeList.vue?vue&type=script&lang=js&"
export * from "./ArtworkIntakeList.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkIntakeList.vue?vue&type=style&index=0&id=13537c49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13537c49",
  null
  
)

export default component.exports